// /* eslint-disable no-unused-vars */
// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import { jsPDF } from "jspdf";
// import { saveAs } from "file-saver";
// import * as XLSX from "xlsx-js-style";
// import autoTable from "jspdf-autotable";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import "./LoanReportTest.css";
// import { ArrowLeftIcon, ArrowRightIcon, Download, FileTextIcon } from "lucide-react";

// const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50,100, "All"];
// const API_URL = "https://payyug.in/api";

// const LoanReportTest = () => {
//   const navigate = useNavigate();
//     const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;

//   const [centers, setCenters] = useState([]);
//   const [selectedCenter, setSelectedCenter] = useState(null);
//   const [groups, setGroups] = useState([]);
//   const [selectedGroup, setSelectedGroup] = useState(null);
//   const [branchs, setBranchs] = useState([]);
//   const [selectedBranch, setSelectedBranch] = useState(null);
//   const [loanType, setLoanType] = useState("");
//     const [company, setCompany] = useState(null);

//   const [loans, setLoans] = useState([]);

//   const [currentPage, setCurrentPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [totalPages, setTotalPages] = useState(1);

//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   /* Helper to format dates safely without throwing errors */
//   const formatDate = (dateStr) => {
//     if (!dateStr) return "N/A";
//     const d = new Date(dateStr);
//     return isNaN(d.getTime()) ? "N/A" : d.toLocaleDateString("en-GB");
//   };

//   /* ================= FETCH BRANCHES ================= */
//   useEffect(() => {
//     const fetchBranch = async () => {
//       try {
//         const res = await axios.get(`${API_URL}/get-branch`, {
//           params: {
//             SuperAdminId: localStorage.getItem("adminuserId"),
//             limit: "all",
//           },
//         });
//         setBranchs(res?.data?.branches || []);
//       } catch (err) {
//         console.error("Error fetching branches:", err);
//       }
//     };

//     fetchBranch();
//   }, []);

//   /* ================= FETCH CENTERS ================= */
//   useEffect(() => {
//     if (!selectedBranch?.id) return;

//     const fetchCenters = async () => {
//       try {
//         const superAdminId = localStorage.getItem("adminuserId");
//         if (!superAdminId) return;

//         const res = await axios.get(`${API_URL}/group/centre`, {
//           params: {
//             superAdminId,
//             branchid: selectedBranch.id,
//             limit: 100000,
//           },
//         });

//         setCenters(res.data?.data || []);
//       } catch (err) {
//         console.error("Error fetching centers:", err);
//       }
//     };

//     fetchCenters();
//   }, [selectedBranch]);

//   /* ================= FETCH GROUPS ================= */
//   useEffect(() => {
//     if (!selectedCenter) return;

//     const fetchGroups = async () => {
//       try {
//         const superAdminId = localStorage.getItem("adminuserId");

//         const res = await axios.get(`${API_URL}/groupupdate/getall`, {
//           params: {
//             superAdminId,
//             CenterId: selectedCenter.id === "all" ? "" : selectedCenter.id || "",
//             limit: 100000,
//           },
//         });

//         setGroups(res.data?.data || []);
//       } catch (err) {
//         console.error("Error fetching groups:", err);
//       }
//     };

//     fetchGroups();
//   }, [selectedCenter]);

//   /* ================= FETCH LOANS ================= */
//   const fetchLoans = async (page = 1, limit = rowsPerPage) => {
//     try {
//       setLoading(true);
//       setError(null);

//       const token = localStorage.getItem("authToken");
//       const superAdminId = localStorage.getItem("adminuserId");

//       const res = await axios.get(`${API_URL}/group-loan/group/list`, {
//         params: {
//           superAdminId,
//           branchId: selectedBranch?.id,
//           centerId: selectedCenter?.id === "all" ? "" : selectedCenter?.id,
//           groupId: selectedGroup?.id === "all" ? "" : selectedGroup?.id,
//           loanType: loanType === "ALL" || loanType === "" ? undefined : loanType,
//           page,
//           limit: limit === "All" ? 100000 : limit,
//         },
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       setLoans(res.data?.data || []);
//       setTotalPages(res.data?.totalPages || 1);
//       setCurrentPage(res.data?.currentPage || 1);
//     } catch (err) {
//       console.error(err);
//       setError("Failed to fetch loans");
//     } finally {
//       setLoading(false);
//     }
//   };

//     useEffect(() => {
//       const fetchCompany = async () => {
//         try {
//           setLoading(true);
//           const response = await fetch(
//             `https://payyug.in/api/get-company?superAdminId=${superAdminId}`,
//           );
//           const data = await response.json();

//           if (response.ok && data) {
//             // Dynamically construct logo URL
//             if (data.logo) {
//               data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
//             }
//             setCompany(data);
//           } else {
//             console.error("Failed to fetch company data");
//           }
//         } catch (err) {
//           console.error("Error fetching company details:", err);
//         } finally {
//           setLoading(false);
//         }
//       };

//       if (superAdminId) fetchCompany();
//     }, [superAdminId]);

//   /* DELETE BUTTON */
//   const handleDelete = async (id) => {
//     const confirmDelete = window.confirm(
//       "Are you sure you want to delete this record?"
//     );

//     if (!confirmDelete) return;

//     try {
//       const token = localStorage.getItem("authToken");

//       await axios.delete(`${API_URL}/group-loan/member/delete/${id}`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       toast.success("Record deleted successfully");
//       setLoans((prev) => prev.filter((loan) => loan.id !== id));
//     } catch (err) {
//       console.error(err);
//       toast.error("Failed to delete record");
//     }
//   };

//   /* ================= FILTER SUBMIT ================= */
//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (!selectedBranch || !selectedCenter) {
//       toast.error("Please select Branch and Center before filtering.");
//       return;
//     }

//     setCurrentPage(1);
//     fetchLoans(1, rowsPerPage);
//   };

//   /* ================= ITEMS PER PAGE CHANGE ================= */
//   const handleItemsPerPageChange = (e) => {
//     const rawVal = e.target.value;
//     const newLimit = rawVal === "All" ? "All" : Number(rawVal);

//     setRowsPerPage(newLimit);
//     setCurrentPage(1);

//     if (selectedBranch && selectedCenter) {
//       fetchLoans(1, newLimit);
//     }
//   };

//   /* Safe Filtering Logic */
//   const filteredLoans =
//     loanType === "" || loanType === "ALL"
//       ? loans
//       : loans.filter((loan) =>
//           (loan.loanType || "")
//             .toLowerCase()
//             .startsWith(loanType.toLowerCase())
//         );

//           const handleDownloadPDF = async () => {
//             const doc = new jsPDF("p", "mm", "a4");
//             const pageWidth = doc.internal.pageSize.width;
//             const pageHeight = doc.internal.pageSize.height;

//             // ================= LOGO =================
//             const logoX = 15;
//             const logoY = 12;
//             const logoSize = 25;
//             const logoPadding = 2;

//             // Border color & thickness
//             doc.setDrawColor(0);
//             doc.setLineWidth(0.2);

//             // Calculate center of logo
//             const centerX = logoX + logoSize / 2;
//             const centerY = logoY + logoSize / 2;

//             // Radius = half of logo + padding
//             const radius = logoSize / 2 + logoPadding;

//             // Draw circle
//             doc.circle(centerX, centerY, radius);

//             // Logo image
//             if (company?.logoUrl) {
//               try {
//                 const logoResp = await fetch(company.logoUrl);
//                 const logoBlob = await logoResp.blob();
//                 const reader = new FileReader();
//                 await new Promise((resolve) => {
//                   reader.onload = () => {
//                     doc.addImage(
//                       reader.result,
//                       "PNG",
//                       logoX,
//                       logoY,
//                       logoSize,
//                       logoSize,
//                     );
//                     resolve();
//                   };
//                   reader.readAsDataURL(logoBlob);
//                 });
//               } catch {
//                 // silent fail
//               }
//             }

//             // ================= COMPANY NAME (AUTO WRAP) =================
//             doc.setFont("helvetica", "bold");
//             doc.setFontSize(14);

//             const nameX = logoX + logoSize + 5;
//             const nameY = 18;
//             const nameMaxWidth = pageWidth - nameX - 15;

//             const companyNameText = doc.splitTextToSize(
//               (company?.name || "COMPANY NAME").toUpperCase(),
//               nameMaxWidth,
//             );

//             doc.text(companyNameText, nameX, nameY);

//             // Calculate Y after company name
//             let currentY = nameY + companyNameText.length * 6;

//             // ================= COMPANY DETAILS =================
//             doc.setFont("helvetica", "normal");
//             doc.setFontSize(11);

//             const detailX = nameX;
//             const detailMaxWidth = nameMaxWidth;

//             // Address
//             const addressText = doc.splitTextToSize(
//               company?.address || "Company Address",
//               detailMaxWidth,
//             );
//             doc.text(addressText, detailX, currentY);
//             currentY += addressText.length * 5;

//             // Email
//             const emailText = doc.splitTextToSize(
//               `Email: ${company?.email || "-"}`,
//               detailMaxWidth,
//             );
//             doc.text(emailText, detailX, currentY);
//             currentY += emailText.length * 5;

//             // Phone
//             const phoneText = doc.splitTextToSize(
//               `Phone: ${company?.contact || "-"}`,
//               detailMaxWidth,
//             );
//             doc.text(phoneText, detailX, currentY);
//             currentY += phoneText.length * 5;

//             // Divider
//             doc.line(10, currentY + 4, pageWidth - 10, currentY + 4);

//             // ================= REPORT TITLE =================
//             doc.setFont("helvetica", "bold");
//             doc.setFontSize(13);
//             doc.text("Group Loan Report", pageWidth / 2, currentY + 14, {
//               align: "center",
//             });

//             const tableColumn = [
//               "SN",
//               "Account No",
//               "Loan Type",
//               "Loan Amount",
//               "Center",
//               "Group",
//               "Member",
//               "Mobile",
//               "Emi Amount",
//               "Disbursal Date",
//               "First Emi Date",
//               "Status",
//             ];

//             const tableRows = filteredLoans.map((item, index) => [
//               index + 1,
//               item?.loanAccountNumber || "N/A",
//               item?.loanType?`Group Loan (${item?.loanType})`:"N/A",
//               item?.loanAmount ? item?.loanAmount : 0,
//               item?.centerName || "N/A",
//               item?.groupName || "N/A",
//               item?.memberName || "N/A",
//               item.member?.mobileNumber || "N/A",
//               item.loanEmiAmount ? item.loanEmiAmount : 0,
//               item.disbursalDate ? new Date(item.disbursalDate).toLocaleDateString("en-GB") : "N/A",
//               item.disbursedfirstDate ? new Date(item.disbursedfirstDate).toLocaleDateString("en-GB") : "N/A",
//               item.status || "N/A",
//             ]);

//             autoTable(doc, {
//               startY: currentY + 20,
//               head: [tableColumn],
//               body: tableRows,

//               theme: "grid",
//               styles: {
//                 fontSize: 7,
//                 cellPadding: 3,
//                 halign: "center",
//               },
//               headStyles: {
//                 fontStyle: "bold",
//                 fontSize: 7,
//               },
//               alternateRowStyles: {
//                 fillColor: [245, 245, 245],
//               },

//               didDrawPage: function () {
//                 const pageWidth = doc.internal.pageSize.width;
//                 const pageHeight = doc.internal.pageSize.height;

//                 doc.setDrawColor(0);
//                 doc.setLineWidth(0.2);

//                 // Page border on EVERY page
//                 doc.rect(8, 8, pageWidth - 16, pageHeight - 16);
//               },
//             });

//             // ================= FOOTER =================
//             const pageCount = doc.internal.getNumberOfPages();
//             for (let i = 1; i <= pageCount; i++) {
//               doc.setPage(i);
//               doc.setFontSize(8);
//               doc.setTextColor(100);
//               doc.text(`Page ${i} of ${pageCount}`, pageWidth - 30, pageHeight - 10);
//               doc.text("Generated by Collection System", 14, pageHeight - 10);
//             }

//             doc.save("Group_Loan_Report.pdf");
//           };

//           const exportExcel = () => {
//             const data = filteredLoans.map((item) => ({
//               "State": item.member?.state || "N/A",
//               "Region": selectedBranch?.name || "N/A",
//               "Branch": selectedBranch?.name || "N/A",
//               "Account No": item?.loanAccountNumber || "N/A",
//               "Loan Type": item?.loanType?`Group Loan (${item?.loanType})`:"N/A",
//               "Loan Amount": item?.loanAmount
//                 ? item?.loanAmount
//                 : 0,
//               "Center Name": item?.centerName || "N/A",
//               "Group Name": item?.groupName || "N/A",
//               "Member Name": item?.memberName || "N/A",
//               "Mobile No.": item.member?.mobileNumber || "N/A",
//               "Emi Amount": item.loanEmiAmount ? item.loanEmiAmount : 0,
//               "Applied Date": item.loanAppliedDate
//                 ? new Date(item.loanAppliedDate).toLocaleDateString("en-GB")
//                 : "N/A",
//               "Approval Date": item.approvalDate
//                 ? new Date(item.approvalDate).toLocaleDateString("en-GB")
//                 : "N/A",
//               "Disbursal Date": item.disbursalDate
//                 ? new Date(item.disbursalDate).toLocaleDateString("en-GB")
//                 : "N/A",
//               "First Emi Date": item?.disbursedfirstDate
//                 ? new Date(item?.disbursedfirstDate).toLocaleDateString("en-GB")
//                 : "N/A",
//             Status: item.status || "N/A",
//             }));

//             const worksheet = XLSX.utils.json_to_sheet(data);

//             // 🔹 Header styling
//             const headerCells = Object.keys(data[0]);
//             headerCells.forEach((_, index) => {
//               const cellRef = XLSX.utils.encode_cell({ r: 0, c: index });
//               worksheet[cellRef].s = {
//                 font: {
//                   bold: true,
//                   color: { rgb: "FFFFFF" },
//                 },
//                 fill: {
//                   fgColor: { rgb: "1F4E78" },
//                 },
//                 alignment: {
//                   horizontal: "center",
//                   vertical: "center",
//                 },
//               };
//             });

//             // 🔹 Auto column width
//             worksheet["!cols"] = headerCells.map((key) => ({
//               wch: Math.max(key.length + 5, 18),
//             }));

//             const workbook = XLSX.utils.book_new();
//             XLSX.utils.book_append_sheet(workbook, worksheet, "Loan Report");

//             XLSX.writeFile(workbook, "Group_Loan_Report.xlsx");
//           };

//   return (
//     <div className="loan-report-container">
//       {/* Top Bar Navigation */}
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           padding: "8px 16px",
//           backgroundColor: "#fff",
//           border: "1px solid #e0e0e0",
//           borderRadius: "8px",
//           marginBottom: "20px",
//           boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
//         }}
//       >
//         <ArrowLeftIcon
//           onClick={() => navigate(-1)}
//           style={{ cursor: "pointer", padding: "4px", borderRadius: "4px" }}
//         />

//         <h2 style={{ margin: 0, fontSize: "18px", fontWeight: "600", color: "#333" }}>
//           Group Loan Report
//         </h2>

//         <ArrowRightIcon
//           onClick={() => navigate(1)}
//           style={{ cursor: "pointer", padding: "4px", borderRadius: "4px" }}
//         />
//       </div>

//       {/* Filter Section */}
//       <section className="loan-report-filter-section">
//         <form className="loan-report-form" onSubmit={handleSubmit}>
//           <div className="loan-report-grid">
//             {/* Branch */}
//             <div className="loan-report-form-group">
//               <label>Select Branch</label>
//               <select
//                 value={selectedBranch?.id || ""}
//                 onChange={(e) => {
//                   const branch = branchs.find(
//                     (br) => br.id === Number(e.target.value)
//                   );
//                   setSelectedBranch(branch || null);
//                   setSelectedCenter(null);
//                   setSelectedGroup(null);
//                   setLoans([]);
//                 }}
//               >
//                 <option value="">Select Branch</option>
//                 {branchs.map((b) => (
//                   <option key={b.id} value={b.id}>
//                     {b.name}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* Center */}
//             <div className="loan-report-form-group">
//               <label>Select Center</label>
//               <select
//                 value={selectedCenter?.id || ""}
//                 disabled={!selectedBranch}
//                 onChange={(e) => {
//                   const val = e.target.value;
//                   if (val === "all") {
//                     setSelectedCenter({ id: "all", CenterName: "All" });
//                   } else {
//                     const center = centers.find((cn) => cn.id === Number(val));
//                     setSelectedCenter(center || null);
//                   }
//                   setSelectedGroup(null);
//                   setLoans([]);
//                 }}
//               >
//                 <option value="">Select Center</option>
//                 <option value="all">All Centers</option>
//                 {centers.map((c) => (
//                   <option key={c.id} value={c.id}>
//                     {c.CenterName}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* Group */}
//             <div className="loan-report-form-group">
//               <label>Select Group</label>
//               <select
//                 value={selectedGroup?.id || ""}
//                 disabled={!selectedCenter}
//                 onChange={(e) => {
//                   const val = e.target.value;
//                   if (val === "all") {
//                     setSelectedGroup({ id: "all", groupname: "All" });
//                   } else {
//                     const group = groups.find((gr) => gr.id === Number(val));
//                     setSelectedGroup(group || null);
//                   }
//                   setLoans([]);
//                 }}
//               >
//                 <option value="">Select Group</option>
//                 <option value="all">All Groups</option>
//                 {groups.map((g) => (
//                   <option key={g.id} value={g.id}>
//                     {g.groupname}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* Loan Type */}
//             <div className="loan-report-form-group">
//               <label>Loan Type</label>
//               <select
//                 value={loanType}
//                 onChange={(e) => setLoanType(e.target.value)}
//               >
//                 <option value="ALL">All</option>
//                 <option value="FIXED">Fixed</option>
//                 <option value="INDIVIDUAL">Individual</option>
//               </select>
//             </div>
//           </div>

//           <button type="submit" className="loan-report-submit-btn">
//             Filter
//           </button>
//         </form>
//       </section>

//       {/* Table Section */}
//       <section className="loan-report-details-section">
//         <div className="loan-report-table-header">
//           <div>
//             <label>Show </label>
//             <select onChange={handleItemsPerPageChange} value={rowsPerPage}>
//               {ITEMS_PER_PAGE_OPTIONS.map((opt) => (
//                 <option key={opt} value={opt}>
//                   {opt}
//                 </option>
//               ))}
//             </select>
//             <span> entries</span>
//           </div>
//           {filteredLoans.length > 0 && (
//                     <div
//                       className=""
//                       style={{ display: "flex", gap: "5px", marginTop: "10px" }}
//                     >
//                       <button
//                         className="collection-report-filter-btn"
//                         style={{ display: "flex", alignItems: "center", gap: "5px" }}
//                         onClick={exportExcel}
//                       >
//                         <FileTextIcon size={18} /> Excel
//                       </button>
//                       <button
//                         className="collection-report-filter-btn"
//                         style={{ display: "flex", alignItems: "center", gap: "5px" }}
//                         onClick={handleDownloadPDF}
//                       >
//                         <Download size={18} /> PDF
//                       </button>
//                     </div>
//                   )}
//         </div>

//         <div className="loan-report-table-container">
//           <table className="loan-report-table">
//             <thead>
//               <tr>
//                 <th>SN</th>
//                 <th>Loan ID</th>
//                 <th>Borrower Name</th>
//                 <th>Loan Amount</th>
//                 <th>Interest Amount</th>
//                 <th>Loan Tenure</th>
//                 <th>Loan Frequency</th>
//                 <th>Applied Date</th>
//                 <th>Approval Date</th>
//                 <th>Disbursal Date</th>
//                 <th>First Emi Date</th>
//                 <th>EMI Amount</th>
//                 <th>Total Payable</th>
//                 <th>Loan Type</th>
//                 <th>Loan Status</th>
//                 <th>View Emi</th>
//                 <th>Approved</th>
//                 <th>Disbursed</th>
//                 <th>Action</th>
//               </tr>
//             </thead>

//             <tbody>
//               {loading ? (
//                 <tr>
//                   <td colSpan="18">Loading...</td>
//                 </tr>
//               ) : error ? (
//                 <tr>
//                   <td colSpan="18">{error}</td>
//                 </tr>
//               ) : filteredLoans.length === 0 ? (
//                 <tr>
//                   <td colSpan="18">No data available</td>
//                 </tr>
//               ) : (
//                 filteredLoans.map((loan, index) => {
//                   const status = loan.status?.toLowerCase();

//                   return (
//                     <tr key={loan.id}>
//                       <td>
//                         {rowsPerPage === "All"
//                           ? index + 1
//                           : (currentPage - 1) * rowsPerPage + index + 1}
//                       </td>
//                       <td>{loan.loanAccountNumber || "N/A"}</td>
//                       <td>{loan.memberName || "N/A"}</td>
//                       <td>{loan.loanAmount || "N/A"}</td>
//                       <td>{loan.loanInterest || "N/A"}</td>
//                       <td>{loan.loanTenure || "N/A"}</td>
//                       <td>{loan.loanRecoveryFrequency || "N/A"}</td>
//                       <td>{formatDate(loan.loanAppliedDate)}</td>
//                       <td>{formatDate(loan.approvalDate)}</td>
//                       <td>{formatDate(loan.disbursalDate)}</td>
//                       <td>{formatDate(loan.disbursedfirstDate)}</td>
//                       <td>{loan.loanEmiAmount || "N/A"}</td>
//                       <td>{loan.loanPayable || "N/A"}</td>
//                       <td>{loan.loanType || "N/A"}</td>
//                       <td>{loan.status || "N/A"}</td>
//                        <td>
//                       {(status==="disbursed"||status==="active") ? (
//                         <button
//                         onClick={() =>
//                           navigate(`/GroupLoanReport/ViewLoanEmi/${loan.id}`, {
//                             state: { loan},
//                           })
//                         }
//                       >
//                         View EMI
//                       </button>
//                       ):(
//                         <span className="">N/A</span>
//                       )}
//                     </td>

//                       <td>
//                         {status === "approved" || status === "active" ? (
//                           <span style={{ color: "green", fontWeight: "700" }}>✔</span>
//                         ) : (
//                           <span style={{ color: "red", fontWeight: "700" }}>X</span>
//                         )}
//                       </td>

//                       <td>
//                         {status === "active" ? (
//                           <span style={{ color: "green", fontWeight: "700" }}>✔</span>
//                         ) : (
//                           <span style={{ color: "red", fontWeight: "700" }}>X</span>
//                         )}
//                       </td>

//                       <td>
//                         <button
//                           className="delete-btn"
//                           onClick={() => handleDelete(loan.id)}
//                         >
//                           Delete
//                         </button>
//                       </td>
//                     </tr>
//                   );
//                 })
//               )}
//             </tbody>
//           </table>
//         </div>
//       </section>

//       {/* Pagination */}
//       {rowsPerPage !== "All" && totalPages > 1 && loans.length > 0 && (
//         <div className="loan-report-pagination">
//           <button
//             onClick={() => {
//               const newPage = currentPage - 1;
//               setCurrentPage(newPage);
//               fetchLoans(newPage, rowsPerPage);
//             }}
//             disabled={currentPage === 1}
//           >
//             ⬅ Prev
//           </button>

//           <span>
//             Page {currentPage} of {totalPages}
//           </span>

//           <button
//             onClick={() => {
//               const newPage = currentPage + 1;
//               setCurrentPage(newPage);
//               fetchLoans(newPage, rowsPerPage);
//             }}
//             disabled={currentPage === totalPages}
//           >
//             Next ➡
//           </button>
//         </div>
//       )}

//       <ToastContainer position="top-right" autoClose={3000} />
//     </div>
//   );
// };

// export default LoanReportTest;

/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { jsPDF } from "jspdf";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx-js-style";
import Select from 'react-select'
import autoTable from "jspdf-autotable";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./LoanReportTest.css";
import {
  ArrowLeftIcon,
  ArrowRightIcon,
  Download,
  FileTextIcon,
} from "lucide-react";

const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50, 100, "All"];
const API_URL = "https://payyug.in/api";

const customSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    height: "40px",
    minHeight: "40px",
    borderRadius: "6px",
    borderColor: state.isDisabled
      ? "#e2e8f0"
      : state.isFocused
        ? "#2563eb"
        : "#cbd5e1",
    boxShadow: state.isFocused ? "0 0 0 3px rgba(37, 99, 235, 0.15)" : "none",
    fontSize: "14px",
    backgroundColor: state.isDisabled ? "#f8fafc" : "#ffffff",
    cursor: state.isDisabled ? "not-allowed" : "pointer",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      borderColor: state.isDisabled
        ? "#e2e8f0"
        : state.isFocused
          ? "#2563eb"
          : "#94a3b8",
    },
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: "40px",
    padding: "0 12px",
  }),
  input: (provided) => ({
    ...provided,
    margin: "0",
    padding: "0",
    color: "#0f172a",
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: state.isDisabled ? "#94a3b8" : "#0f172a",
    fontSize: "14px",
    fontWeight: "500",
  }),
  placeholder: (provided, state) => ({
    ...provided,
    color: state.isDisabled ? "#cbd5e1" : "#64748b",
    fontSize: "14px",
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: "40px",
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    padding: "8px",
    color: state.isDisabled ? "#cbd5e1" : "#64748b",
    "&:hover": {
      color: state.isDisabled ? "#cbd5e1" : "#334155",
    },
  }),
  clearIndicator: (provided) => ({
    ...provided,
    padding: "8px",
    color: "#94a3b8",
    "&:hover": {
      color: "#ef4444",
    },
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "6px",
    boxShadow:
      "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    border: "1px solid #e2e8f0",
    overflow: "hidden",
    marginTop: "4px",
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: "14px",
    padding: "10px 12px",
    backgroundColor: state.isSelected
      ? "#2563eb"
      : state.isFocused
        ? "#eff6ff"
        : "#ffffff",
    color: state.isSelected ? "#ffffff" : "#1e293b",
    cursor: "pointer",
    active: {
      backgroundColor: "#dbeafe",
    },
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

const LoanReportTest = () => {
  const navigate = useNavigate();
  const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;

  const [centers, setCenters] = useState([]);
  const [selectedCenter, setSelectedCenter] = useState(null);
  const [groups, setGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [branchs, setBranchs] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [loanType, setLoanType] = useState("");
  const [company, setCompany] = useState(null);

  const [loans, setLoans] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  /* Helper to format dates safely without throwing errors */
  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    const d = new Date(dateStr);
    return isNaN(d.getTime()) ? "N/A" : d.toLocaleDateString("en-GB");
  };

  /* ================= FETCH BRANCHES ================= */
  useEffect(() => {
    const fetchBranch = async () => {
      try {
        const res = await axios.get(`${API_URL}/get-branch`, {
          params: {
            SuperAdminId: localStorage.getItem("adminuserId"),
            limit: "all",
          },
        });
        setBranchs(res?.data?.branches || []);
      } catch (err) {
        console.error("Error fetching branches:", err);
      }
    };

    fetchBranch();
  }, []);

  /* ================= FETCH CENTERS ================= */
  useEffect(() => {
    if (!selectedBranch?.value) return;

    const fetchCenters = async () => {
      try {
        const superAdminId = localStorage.getItem("adminuserId");
        if (!superAdminId) return;

        const res = await axios.get(`${API_URL}/group/centre`, {
          params: {
            superAdminId,
            branchid: selectedBranch.value,
            limit: 100000,
          },
        });

        setCenters(res.data?.data || []);
      } catch (err) {
        console.error("Error fetching centers:", err);
      }
    };

    fetchCenters();
  }, [selectedBranch]);

  /* ================= FETCH GROUPS ================= */
  useEffect(() => {
    if (!selectedCenter) return;

    const fetchGroups = async () => {
      try {
        const superAdminId = localStorage.getItem("adminuserId");

        const res = await axios.get(`${API_URL}/groupupdate/getall`, {
          params: {
            superAdminId,
            CenterId:selectedCenter?.value,
            limit: 100000,
          },
        });

        setGroups(res.data?.data || []);
      } catch (err) {
        console.error("Error fetching groups:", err);
      }
    };

    fetchGroups();
  }, [selectedCenter]);

  /* ================= FETCH LOANS ================= */
  const fetchLoans = async (page = 1, limit = rowsPerPage) => {
    try {
      setLoading(true);
      setError(null);

      const token = localStorage.getItem("authToken");
      const superAdminId = localStorage.getItem("adminuserId");

      const res = await axios.get(`${API_URL}/group-loan/group/list`, {
        params: {
          superAdminId,
          branchId:selectedBranch?.value||undefined,
          centerId: selectedCenter?.value||undefined,
          groupId: selectedGroup?.value||undefined,
          loanType:
            loanType === "ALL" || loanType === "" ? undefined : loanType,
          page,
          limit: limit === "All" ? 100000 : limit,
        },
        headers: { Authorization: `Bearer ${token}` },
      });

      setLoans(res.data?.data || []);
      setTotalPages(res.data?.totalPages || 1);
      setCurrentPage(res.data?.currentPage || 1);
    } catch (err) {
      console.error(err);
      setError("Failed to fetch loans");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
  // Page 1 par reset karein jab bhi primary filters badle (optional UX improvement)
  fetchLoans();
}, [selectedBranch, selectedCenter, selectedGroup, loanType, rowsPerPage]);

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `https://payyug.in/api/get-company?superAdminId=${superAdminId}`,
        );
        const data = await response.json();

        if (response.ok && data) {
          // Dynamically construct logo URL
          if (data.logo) {
            data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
          }
          setCompany(data);
        } else {
          console.error("Failed to fetch company data");
        }
      } catch (err) {
        console.error("Error fetching company details:", err);
      } finally {
        setLoading(false);
      }
    };

    if (superAdminId) fetchCompany();
  }, [superAdminId]);

  /* DELETE BUTTON */
  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this record?",
    );

    if (!confirmDelete) return;

    try {
      const token = localStorage.getItem("authToken");

      await axios.delete(`${API_URL}/group-loan/member/delete/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      toast.success("Record deleted successfully");
      setLoans((prev) => prev.filter((loan) => loan.id !== id));
    } catch (err) {
      console.error(err);
      toast.error("Failed to delete record");
    }
  };

  /* ================= FILTER SUBMIT ================= */
  const handleFilter = () => {
    setCurrentPage(1);
    fetchLoans(1, rowsPerPage);
  };

  /* ================= ITEMS PER PAGE CHANGE ================= */
  const handleItemsPerPageChange = (e) => {
    const rawVal = e.target.value;
    const newLimit = rawVal === "All" ? "All" : Number(rawVal);

    setRowsPerPage(newLimit);
    setCurrentPage(1);

    if (selectedBranch && selectedCenter) {
      fetchLoans(1, newLimit);
    }
  };

  /* Safe Filtering Logic */
  const filteredLoans =
    loanType === "" || loanType === "ALL"
      ? loans
      : loans.filter((loan) =>
          (loan.loanType || "")
            .toLowerCase()
            .startsWith(loanType.toLowerCase()),
        );

  const handleDownloadPDF = async () => {
    const doc = new jsPDF("p", "mm", "a4");
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;

    // ================= LOGO =================
    const logoX = 15;
    const logoY = 12;
    const logoSize = 25;
    const logoPadding = 2;

    // Border color & thickness
    doc.setDrawColor(0);
    doc.setLineWidth(0.2);

    // Calculate center of logo
    const centerX = logoX + logoSize / 2;
    const centerY = logoY + logoSize / 2;

    // Radius = half of logo + padding
    const radius = logoSize / 2 + logoPadding;

    // Draw circle
    doc.circle(centerX, centerY, radius);

    // Logo image
    if (company?.logoUrl) {
      try {
        const logoResp = await fetch(company.logoUrl);
        const logoBlob = await logoResp.blob();
        const reader = new FileReader();
        await new Promise((resolve) => {
          reader.onload = () => {
            doc.addImage(
              reader.result,
              "PNG",
              logoX,
              logoY,
              logoSize,
              logoSize,
            );
            resolve();
          };
          reader.readAsDataURL(logoBlob);
        });
      } catch {
        // silent fail
      }
    }

    // ================= COMPANY NAME (AUTO WRAP) =================
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);

    const nameX = logoX + logoSize + 5;
    const nameY = 18;
    const nameMaxWidth = pageWidth - nameX - 15;

    const companyNameText = doc.splitTextToSize(
      (company?.name || "COMPANY NAME").toUpperCase(),
      nameMaxWidth,
    );

    doc.text(companyNameText, nameX, nameY);

    // Calculate Y after company name
    let currentY = nameY + companyNameText.length * 6;

    // ================= COMPANY DETAILS =================
    doc.setFont("helvetica", "normal");
    doc.setFontSize(11);

    const detailX = nameX;
    const detailMaxWidth = nameMaxWidth;

    // Address
    const addressText = doc.splitTextToSize(
      company?.address || "Company Address",
      detailMaxWidth,
    );
    doc.text(addressText, detailX, currentY);
    currentY += addressText.length * 5;

    // Email
    const emailText = doc.splitTextToSize(
      `Email: ${company?.email || "-"}`,
      detailMaxWidth,
    );
    doc.text(emailText, detailX, currentY);
    currentY += emailText.length * 5;

    // Phone
    const phoneText = doc.splitTextToSize(
      `Phone: ${company?.contact || "-"}`,
      detailMaxWidth,
    );
    doc.text(phoneText, detailX, currentY);
    currentY += phoneText.length * 5;

    // Divider
    doc.line(10, currentY + 4, pageWidth - 10, currentY + 4);

    // ================= REPORT TITLE =================
    doc.setFont("helvetica", "bold");
    doc.setFontSize(13);
    doc.text("Group Loan Report", pageWidth / 2, currentY + 14, {
      align: "center",
    });

    const tableColumn = [
      "SN",
      "Account No",
      "Loan Type",
      "Loan Amount",
      "Center",
      "Group",
      "Member",
      "Mobile",
      "Emi Amount",
      "Disbursal Date",
      "First Emi Date",
      "Status",
    ];

    const tableRows = filteredLoans.map((item, index) => [
      index + 1,
      item?.loanAccountNumber || "N/A",
      item?.loanType ? `Group Loan (${item?.loanType})` : "N/A",
      item?.loanAmount ? item?.loanAmount : 0,
      item?.centerName || "N/A",
      item?.groupName || "N/A",
      item?.memberName || "N/A",
      item.member?.mobileNumber || "N/A",
      item.loanEmiAmount ? item.loanEmiAmount : 0,
      item.disbursalDate
        ? new Date(item.disbursalDate).toLocaleDateString("en-GB")
        : "N/A",
      item.disbursedfirstDate
        ? new Date(item.disbursedfirstDate).toLocaleDateString("en-GB")
        : "N/A",
      item.status || "N/A",
    ]);

    autoTable(doc, {
      startY: currentY + 20,
      head: [tableColumn],
      body: tableRows,

      theme: "grid",
      styles: {
        fontSize: 7,
        cellPadding: 3,
        halign: "center",
      },
      headStyles: {
        fontStyle: "bold",
        fontSize: 7,
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245],
      },

      didDrawPage: function () {
        const pageWidth = doc.internal.pageSize.width;
        const pageHeight = doc.internal.pageSize.height;

        doc.setDrawColor(0);
        doc.setLineWidth(0.2);

        // Page border on EVERY page
        doc.rect(8, 8, pageWidth - 16, pageHeight - 16);
      },
    });

    // ================= FOOTER =================
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.setTextColor(100);
      doc.text(`Page ${i} of ${pageCount}`, pageWidth - 30, pageHeight - 10);
      doc.text("Generated by Collection System", 14, pageHeight - 10);
    }

    doc.save("Group_Loan_Report.pdf");
  };

  const exportExcel = () => {
    const data = filteredLoans.map((item) => ({
      State: item.member?.state || "N/A",
      Region: selectedBranch?.name || "N/A",
      Branch: selectedBranch?.name || "N/A",
      "Account No": item?.loanAccountNumber || "N/A",
      "Loan Type": item?.loanType ? `Group Loan (${item?.loanType})` : "N/A",
      "Loan Amount": item?.loanAmount ? item?.loanAmount : 0,
      "Center Name": item?.centerName || "N/A",
      "Group Name": item?.groupName || "N/A",
      "Member Name": item?.memberName || "N/A",
      "Mobile No.": item.member?.mobileNumber || "N/A",
      "Emi Amount": item.loanEmiAmount ? item.loanEmiAmount : 0,
      "Applied Date": item.loanAppliedDate
        ? new Date(item.loanAppliedDate).toLocaleDateString("en-GB")
        : "N/A",
      "Approval Date": item.approvalDate
        ? new Date(item.approvalDate).toLocaleDateString("en-GB")
        : "N/A",
      "Disbursal Date": item.disbursalDate
        ? new Date(item.disbursalDate).toLocaleDateString("en-GB")
        : "N/A",
      "First Emi Date": item?.disbursedfirstDate
        ? new Date(item?.disbursedfirstDate).toLocaleDateString("en-GB")
        : "N/A",
      Status: item.status || "N/A",
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);

    // 🔹 Header styling
    const headerCells = Object.keys(data[0]);
    headerCells.forEach((_, index) => {
      const cellRef = XLSX.utils.encode_cell({ r: 0, c: index });
      worksheet[cellRef].s = {
        font: {
          bold: true,
          color: { rgb: "FFFFFF" },
        },
        fill: {
          fgColor: { rgb: "1F4E78" },
        },
        alignment: {
          horizontal: "center",
          vertical: "center",
        },
      };
    });

    // 🔹 Auto column width
    worksheet["!cols"] = headerCells.map((key) => ({
      wch: Math.max(key.length + 5, 18),
    }));

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Loan Report");

    XLSX.writeFile(workbook, "Group_Loan_Report.xlsx");
  };


  const branchOptions = branchs.map((b) => ({
    value: b.id,
    label: b.name,
  }));

  const centerOptions = centers.map((c) => ({
    value: c.id,
    label: c.CenterName,
  }));

  const groupOptions = groups.map((g) => ({
    value: g.id,
    label: `${g.groupname} (${g.groupcode})`,
  }));

  return (
    <div className="loan-report-container">
      {/* Top Bar Navigation */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "8px 16px",
          backgroundColor: "#fff",
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          marginBottom: "20px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
        }}
      >
        <ArrowLeftIcon
          onClick={() => navigate(-1)}
          style={{ cursor: "pointer", padding: "4px", borderRadius: "4px" }}
        />

        <h2
          style={{
            margin: 0,
            fontSize: "18px",
            fontWeight: "600",
            color: "#333",
          }}
        >
          Group Loan Report
        </h2>

        <ArrowRightIcon
          onClick={() => navigate(1)}
          style={{ cursor: "pointer", padding: "4px", borderRadius: "4px" }}
        />
      </div>

      {/* Filter Section */}
      <section className="loan-report-filter-section">
        <div className="loan-report-form">
          <div className="loan-report-grid">
            {/* Branch */}
            <div className="loan-report-form-group">
              <label>Select Branch</label>
              <Select
                options={branchOptions}
                value={selectedBranch}
                onChange={(option) => {
                  setSelectedBranch(option);
                  setSelectedCenter(null); 
                  setSelectedGroup(null); 
                }}
                placeholder="Search or Select Branch"
                isClearable
                isSearchable
                styles={customSelectStyles}
                menuPortalTarget={document.body}
              />
            </div>

            {/* Center */}
            <div className="loan-report-form-group">
              <label>Select Center</label>
              <Select
                options={centerOptions}
                value={selectedCenter}
                onChange={(option) => {
                  setSelectedCenter(option);
                  setSelectedGroup(null);
                }}
                placeholder="Search or Select Center"
                isDisabled={!selectedBranch}
                isClearable
                isSearchable
                styles={customSelectStyles}
                menuPortalTarget={document.body}
              />
            </div>

            {/* Group */}
            <div className="loan-report-form-group">
              <label>Select Group</label>
               <Select
                options={groupOptions}
                value={selectedGroup}
                onChange={(option) => setSelectedGroup(option)}
                placeholder={
                  selectedCenter ? "Search or Select Group" : "Select Center First"
                }
                isDisabled={!selectedCenter}
                isClearable
                isSearchable
                styles={customSelectStyles}
                menuPortalTarget={document.body}
              />
            </div>

            {/* Loan Type */}
            <div className="loan-report-form-group">
              <label>Loan Type</label>
              <select
                value={loanType}
                onChange={(e) => setLoanType(e.target.value)}
              >
                <option value="ALL">All</option>
                <option value="FIXED">Fixed</option>
                <option value="INDIVIDUAL">Individual</option>
              </select>
            </div>
          </div>

          <button type="submit" className="loan-report-submit-btn" onClick={handleFilter}>
            Filter
          </button>
        </div>
      </section>

      {/* Table Section */}
      <section className="loan-report-details-section">
        <div className="loan-report-table-header">
          <div>
            <label>Show </label>
            <select onChange={handleItemsPerPageChange} value={rowsPerPage}>
              {ITEMS_PER_PAGE_OPTIONS.map((opt) => (
                <option key={opt} value={opt}>
                  {opt}
                </option>
              ))}
            </select>
            <span> entries</span>
          </div>
          {filteredLoans.length > 0 && (
            <div
              className=""
              style={{ display: "flex", gap: "5px", marginTop: "10px" }}
            >
              <button
                className="collection-report-filter-btn"
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
                onClick={exportExcel}
              >
                <FileTextIcon size={18} /> Excel
              </button>
              <button
                className="collection-report-filter-btn"
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
                onClick={handleDownloadPDF}
              >
                <Download size={18} /> PDF
              </button>
            </div>
          )}
        </div>

        <div className="loan-report-table-container">
          <table className="loan-report-table">
            <thead>
              <tr>
                <th>SN</th>
                <th>Loan ID</th>
                <th>Borrower Name</th>
                <th>Loan Amount</th>
                <th>Interest Amount</th>
                <th>Loan Tenure</th>
                <th>Loan Frequency</th>
                <th>Applied Date</th>
                <th>Approval Date</th>
                <th>Disbursal Date</th>
                <th>First Emi Date</th>
                <th>EMI Amount</th>
                <th>Total Payable</th>
                <th>Loan Type</th>
                <th>Loan Status</th>
                <th>View Emi</th>
                <th>Approved</th>
                <th>Disbursed</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="18">Loading...</td>
                </tr>
              ) : error ? (
                <tr>
                  <td colSpan="18">{error}</td>
                </tr>
              ) : filteredLoans.length === 0 ? (
                <tr>
                  <td colSpan="18">No data available</td>
                </tr>
              ) : (
                filteredLoans.map((loan, index) => {
                  const status = loan.status?.toLowerCase();

                  return (
                    <tr key={loan.id}>
                      <td>
                        {rowsPerPage === "All"
                          ? index + 1
                          : (currentPage - 1) * rowsPerPage + index + 1}
                      </td>
                      <td>{loan.loanAccountNumber || "N/A"}</td>
                      <td>{loan.memberName || "N/A"}</td>
                      <td>{loan.loanAmount || "N/A"}</td>
                      <td>{loan.loanInterest || "N/A"}</td>
                      <td>{loan.loanTenure || "N/A"}</td>
                      <td>{loan.loanRecoveryFrequency || "N/A"}</td>
                      <td>{formatDate(loan.loanAppliedDate)}</td>
                      <td>{formatDate(loan.approvalDate)}</td>
                      <td>{formatDate(loan.disbursalDate)}</td>
                      <td>{formatDate(loan.disbursedfirstDate)}</td>
                      <td>{loan.loanEmiAmount || "N/A"}</td>
                      <td>{loan.loanPayable || "N/A"}</td>
                      <td>{loan.loanType || "N/A"}</td>
                      <td>{loan.status || "N/A"}</td>
                      <td>
                        {status === "disbursed" || status === "active" ? (
                          <button
                            onClick={() =>
                              navigate(
                                `/GroupLoanReport/ViewLoanEmi/${loan.id}`,
                                {
                                  state: { loan },
                                },
                              )
                            }
                          >
                            View EMI
                          </button>
                        ) : (
                          <span className="">N/A</span>
                        )}
                      </td>

                      <td>
                        {status === "approved" || status === "active" ? (
                          <span style={{ color: "green", fontWeight: "700" }}>
                            ✔
                          </span>
                        ) : (
                          <span style={{ color: "red", fontWeight: "700" }}>
                            X
                          </span>
                        )}
                      </td>

                      <td>
                        {status === "active" ? (
                          <span style={{ color: "green", fontWeight: "700" }}>
                            ✔
                          </span>
                        ) : (
                          <span style={{ color: "red", fontWeight: "700" }}>
                            X
                          </span>
                        )}
                      </td>

                      <td>
                        <button
                          className="delete-btn"
                          onClick={() => handleDelete(loan.id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </section>

      {/* Pagination */}
      {rowsPerPage !== "All" && totalPages > 1 && loans.length > 0 && (
        <div className="loan-report-pagination">
          <button
            onClick={() => {
              const newPage = currentPage - 1;
              setCurrentPage(newPage);
              fetchLoans(newPage, rowsPerPage);
            }}
            disabled={currentPage === 1}
          >
            ⬅ Prev
          </button>

          <span>
            Page {currentPage} of {totalPages}
          </span>

          <button
            onClick={() => {
              const newPage = currentPage + 1;
              setCurrentPage(newPage);
              fetchLoans(newPage, rowsPerPage);
            }}
            disabled={currentPage === totalPages}
          >
            Next ➡
          </button>
        </div>
      )}

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default LoanReportTest;
